import React, { createContext, useContext, ReactNode } from 'react';
import useLocalStorage from 'hooks/use-local-storage/use-local-storage';

type UniqueDataContextType = {
  showUniqueData: boolean;
  setShowUniqueData: (value: boolean) => void;
};

const UniqueDataContext = createContext<UniqueDataContextType | undefined>(
  undefined,
);

export const UniqueDataProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [showUniqueData, setShowUniqueData] = useLocalStorage<boolean>(
    'showUniqueData',
    true,
  );

  return (
    <UniqueDataContext.Provider value={{ showUniqueData, setShowUniqueData }}>
      {children}
    </UniqueDataContext.Provider>
  );
};

export const useUniqueData = (): UniqueDataContextType => {
  const context = useContext(UniqueDataContext);
  if (context === undefined) {
    throw new Error('useUniqueData must be used within a UniqueDataProvider');
  }
  return context;
};
